/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";

interface Point {
  x: number;
  y: number;
}

export interface CropArea {
  x: number;
  y: number;
  width: number;
  height: number;
}

interface ImageCropperProps {
  previewUrl: string | null;
  onCropComplete?: (croppedAreaPixels: CropArea) => void;
}

const ImageCropper: React.FC<ImageCropperProps> = ({
  previewUrl,
  onCropComplete,
}) => {
  // ✅ crop is Point type for library
  const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<CropArea | null>(
    null,
  );

  const onCropCompleteCallback = useCallback(
    (croppedArea: CropArea, croppedAreaPixels: CropArea) => {
      setCroppedAreaPixels(croppedAreaPixels);
      onCropComplete?.(croppedAreaPixels);
    },
    [onCropComplete],
  );

  if (!previewUrl) return null;

  return (
    <div style={{ position: "relative", height: "350px", width: "100%" }}>
      <Cropper
        image={previewUrl}
        crop={crop}
        zoom={zoom}
        rotation={rotation}
        aspect={1}
        onCropChange={setCrop}
        onZoomChange={setZoom}
        onRotationChange={setRotation}
        onCropComplete={onCropCompleteCallback}
        maxZoom={3}
        zoomWithScroll={true}
        cropShape="round"
        showGrid={true}
      />
    </div>
  );
};

export default ImageCropper;
